let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("grG1M")).then(() => parcelRequire('a6h9M'));